module.exports = __webpack_public_path__ + "static/media/barcode-alt-icon-form.a6f6930b.svg";